import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrencyPipe, DialogBase, ObjectTypeInfo, T4RentalService } from 't4core';
import { RentalObjectInfo, SparepartPriceModel } from '../../../../../projects/t4core/src/public-api';

@Component({
  selector: 't4-AddCostDialog',
  templateUrl: 'AddCostDialog.html',
})
export class AddCostDialog extends DialogBase implements OnInit {
  public rentalId: number = 0;
  public isSparePartsDefault: boolean = false;
  public selectedType: number = 3;
  public items: ObjectTypeInfo[] = [];

  public selectedItem: ObjectTypeInfo;
  public amount: number = 0;
  public description: string = "";

  public isLoadingItems: boolean = true;
  public isLoadingPrice: boolean = false;

  constructor(public dialogRef: MatDialogRef<AddCostDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private rentalService: T4RentalService, private cPipe: CurrencyPipe) {
    super("AddCostDialog");

    this.rentalId = data.rentalId;
    if (data.isSparePartsDefault)
      this.isSparePartsDefault = data.isSparePartsDefault;
  }

  async ngOnInit() {
    if (this.isSparePartsDefault) {
      this.selectedType = 1; 
    }
      
    this.selectType(this.selectedType);
    console.log(this.data);
  }

  async selectType(type: number) {
    this.isLoadingItems = true;
    this.items = await this.Api.get<ObjectTypeInfo[]>("RentalObject/GetAllTypes", { type: type });
    if (this.items) {
      this.selectedItem = this.items[0];
      this.selectItem(this.selectedItem);
    }
    this.isLoadingItems = false;
  }

  async selectItem(item: ObjectTypeInfo) {
    this.isLoadingPrice = true;
    this.selectedItem = item;

    if (this.selectedType == 3 || this.selectedType == 1) this.amount = await this.Api.get<number>("Price/GetItemPrice", { objectTypeId: this.selectedItem.Id });
   

    this.isLoadingPrice = false;
  }

  public async validate() {
    if (await this.Api.post<number>("Price/AddCost", null, { itemId: this.selectedItem.Id, amount: this.amount, description: this.description, rentalId: this.rentalId })) {
      this.close(true);
    }
  }

  public close(flag: boolean = false) {
    this.dialogRef.close(flag);
  }
}
